// removed by extract-text-webpack-plugin
module.exports = {"highlight-top-product-tab":"highlight-top-product-tab","wrap-top-product":"wrap-top-product","top-product-list":"top-product-list","product":"product"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_TopProductTab.scss
// module id = ./components/home/sub-view/_TopProductTab.scss
// module chunks = 0